/* firmanumre-kort.js
   Oenskeliste, hurtigt koeb og hurtigt kig. Ren vanilla, ingen jQuery.

   OENSKELISTEN ligger i localStorage under `fn_oenskeliste`. Der kraeves
   derfor intet login, og listen foelger enheden. Hver post gemmer alt hvad
   /pages/onskeliste skal bruge for at tegne kortet igen, saa siden ikke skal
   slaa noget op. Prisen kan naa at aendre sig; derfor hentes den friske pris
   fra /products/<handle>.js, naar listen tegnes.

   HURTIGT KOEB sender varianten til /cart/add.js. Alle guldnumre er unikke og
   har praecis een variant uden tilvalg, saa der er intet at vaelge.
*/
(function () {
  'use strict';

  var NOEGLE = 'fn_oenskeliste';

  /* ---------- lager ---------- */

  function laes() {
    try { return JSON.parse(window.localStorage.getItem(NOEGLE) || '[]'); }
    catch (e) { return []; }
  }
  function skriv(liste) {
    try { window.localStorage.setItem(NOEGLE, JSON.stringify(liste)); } catch (e) {}
    opdaterTal();
    window.dispatchEvent(new CustomEvent('fn:oenskeliste', { detail: liste }));
  }
  function harHandle(h) { return laes().some(function (x) { return x.handle === h; }); }

  function opdaterTal() {
    var n = laes().length;
    var el = document.querySelectorAll('[data-fn-oenske-tal]');
    /* Uændret textContent udløser også childList-observeren i start().
       Skriv kun ændrede tal, så bind() ikke starter sig selv igen i tomgang. */
    for (var i = 0; i < el.length; i++) { saetTekst(el[i], String(n)); el[i].hidden = n === 0; }
    var el2 = document.querySelectorAll('[data-fn-oenske-tal-2]');
    for (var j = 0; j < el2.length; j++) { saetTekst(el2[j], n ? '(' + n + ')' : ''); }
  }

  /* ---------- sidelaasen ---------- */

  /* Samme laas som kurven bruger, og af samme grund: `overscroll-behavior`
     alene holder ikke baggrunden i ro, naar arket ikke selv kan rulle, og
     iOS Safari lader siden gummi-rulle uanset. Paa telefon er `position:
     fixed` paa body den eneste laas iOS respekterer; paa desktop ville den
     flytte den synlige side, saa der bruges `overflow: hidden`. Rulhoejden
     gemmes og gives tilbage i begge tilfaelde.
     Se afsnittet "Kurven: sidelaas og bevaegelse" i CLAUDE.md. */
  var laastY = 0, erLaast = false, fastLaast = false;

  function telefon() { return window.matchMedia('(max-width: 768px)').matches; }

  function laasSiden() {
    if (erLaast) return;
    erLaast = true;
    var h = document.documentElement;
    /* To flader kan vaere aabne samtidig - arket, og kurven oven paa det - og
       kurven har sin egen laas i firmanumre-kurv.js. Uden en faelles taeller
       ville den anden laas laese `pageYOffset` som 0, fordi body allerede er
       fastlaast, og siden ville springe til toppen, naar den slap.
       Taelleren og den gemte rulhoejde deles derfor gennem html-elementet,
       som begge filer kan se. */
    var n = parseInt(h.getAttribute('data-fn-laast') || '0', 10);
    h.setAttribute('data-fn-laast', String(n + 1));
    if (n > 0) return;
    laastY = window.pageYOffset || h.scrollTop || 0;
    h.setAttribute('data-fn-laast-y', String(laastY));
    var b = document.body;
    var bjaelke = window.innerWidth - h.clientWidth;
    h.style.overflow = 'hidden';
    b.style.overflow = 'hidden';
    if (bjaelke > 0) b.style.paddingRight = bjaelke + 'px';
    if (telefon()) {
      fastLaast = true;
      b.style.position = 'fixed';
      b.style.top = (-laastY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    }
  }

  function laasOp() {
    if (!erLaast) return;
    erLaast = false;
    var h = document.documentElement;
    var n = parseInt(h.getAttribute('data-fn-laast') || '1', 10) - 1;
    if (n > 0) { h.setAttribute('data-fn-laast', String(n)); return; }
    var y = parseInt(h.getAttribute('data-fn-laast-y') || '0', 10);
    h.removeAttribute('data-fn-laast');
    h.removeAttribute('data-fn-laast-y');
    var b = document.body;
    h.style.overflow = '';
    b.style.overflow = '';
    b.style.paddingRight = '';
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    fastLaast = false;
    window.scrollTo(0, y);
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- hjertet ---------- */

  function opsaetHjerter() {
    var knapper = document.querySelectorAll('[data-fn-hjerte]');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i];
      k.setAttribute('aria-pressed', harHandle(k.dataset.handle) ? 'true' : 'false');
      if (k.dataset.fnBundet) continue;
      k.dataset.fnBundet = '1';
      k.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var d = this.dataset;
        var liste = laes();
        var fandtes = liste.some(function (x) { return x.handle === d.handle; });
        if (fandtes) {
          liste = liste.filter(function (x) { return x.handle !== d.handle; });
        } else {
          liste.unshift({ handle: d.handle, titel: d.titel, type: d.type,
                          pris: d.pris, billede: d.billede, url: d.url });
        }
        skriv(liste);
        this.setAttribute('aria-pressed', fandtes ? 'false' : 'true');
      });
    }
  }

  /* ---------- hurtigt koeb ---------- */

  function aabenKurv() {
    /* Temaets skuffe aabnes af en knap i headeren. Findes den ikke, sendes
       kunden til /cart, saa handlingen aldrig ender blindt. */
    var t = document.querySelector('.js-drawer-open-button-right, [data-fn-aaben-kurv]');
    if (t) { t.click(); return true; }
    return false;
  }

  /* ---------- indlaesningstilstand paa koebsknapper ----------

     Telenors knap-spinner (se firmanumre-brand.css). Markup'en saettes her og
     ikke i Liquid, fordi knapperne findes fem steder og flere af dem foerst
     bygges af JavaScript. Der er ALTID en sikkerhedstimer: fejler et
     faerdig-signal, stopper spinneren af sig selv i stedet for at koere videre
     i det uendelige. */

  var LOAD_MAKS = 8000;

  /* ---------- "ligger allerede i kurven" ----------

     Et guldnummer findes kun én gang og har praecis én variant. Ligger det i
     kurven, er der intet at laegge i, og en ny tilfoejelse ville blot saette
     antallet op paa en vare der kun findes i ét eksemplar. Knappen slaas
     derfor fra.

     Sandheden er SERVERENS kurv, ikke knappens egen historik: window.fnKurv
     (firmanumre-kurv.js) laeser /cart.js og udsender fn:kurv, naar
     sammensaetningen aendrer sig. Derfor retter knapperne ogsaa sig selv, hvis
     kunden fjerner nummeret igen i skuffen, eller hvis 20-minutters-uret
     toemmer kurven.

     VIGTIGT: der skrives kun, naar vaerdien faktisk aendrer sig. bind() koeres
     af en MutationObserver paa document.body, saa en ubetinget skrivning til
     textContent ville udloese en ny mutation og dermed en uendelig loekke. */

  function iKurven(id) {
    return !!(window.fnKurv && id && window.fnKurv.harVariant(id));
  }

  /* Etiketten skal ALTID vaere et element, aldrig knappen selv. To grunde:
     en skrivning til knappens egen textContent ville slette spinneren igen,
     og loaderens regel `> *:not(.fn-load__spinner)` kan ikke skjule en bar
     tekstknude. Den sticky bjaelkes knap har netop bar tekst, saa den faar et
     span foerste gang den roeres. */
  function tekstFelt(knap) {
    var el = knap.querySelector('.btn__add-to-cart-text')
          || knap.querySelector('span:not(.fn-load__spinner):not(.fn-load__a):not(.fn-load__b)');
    if (el) return el;
    var s = document.createElement('span');
    s.className = 'fn-knap__tekst';
    while (knap.firstChild && knap.firstChild.nodeType === 3) s.appendChild(knap.firstChild);
    knap.insertBefore(s, knap.firstChild);
    return s;
  }

  function saetTekst(el, ny) { if (el && el.textContent !== ny) el.textContent = ny; }

  /* Teksten roeres IKKE. Knappen bliver blot utilgaengelig og daempet
     (Richard 08.09.2026): `disabled` plus data-fn-i-kurv, som CSS'en giver
     lavere opacity og pointer-events: none. */
  function saetKurvKnap(knap) {
    var inde = iKurven(knap.dataset.variant);
    if (knap.disabled !== inde) knap.disabled = inde;
    saetLaast(knap, inde);
  }

  function saetLaast(knap, inde) {
    if (inde) { if (knap.getAttribute('data-fn-i-kurv') !== '1') knap.setAttribute('data-fn-i-kurv', '1'); }
    else if (knap.hasAttribute('data-fn-i-kurv')) knap.removeAttribute('data-fn-i-kurv');
  }

  /* Produktsidens knap og den sticky bjaelkes knap sender samme formular, saa
     de deler variant. Et SOLGT nummer er slaaet fra af temaet i forvejen -
     den tilstand huskes, saa knappen ikke bliver aabnet ved et uheld, naar
     nummeret fjernes fra kurven igen. */
  function saetPdpKnapper() {
    var knapper = document.querySelectorAll('.btn--add-to-cart, [data-fn-sticky-knap]');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i];
      var form = k.form || (k.closest ? k.closest('form') : null);
      if (!form) form = document.getElementById(k.getAttribute('form') || '');
      var felt = form ? form.querySelector('[name="id"]') : null;
      if (!felt) continue;
      tekstFelt(k);
      if (!k.dataset.fnGrundlaast) k.dataset.fnGrundlaast = k.disabled ? '1' : '0';
      var inde = iKurven(felt.value);
      var laast = inde || k.dataset.fnGrundlaast === '1';
      if (k.disabled !== laast) k.disabled = laast;
      saetLaast(k, inde);
    }
  }

  function opdaterKurvKnapper() {
    var k = document.querySelectorAll('[data-fn-kurv]');
    for (var i = 0; i < k.length; i++) saetKurvKnap(k[i]);
    saetPdpKnapper();
  }

  function loadStart(knap, maks) {
    if (!knap || knap.getAttribute('aria-busy') === 'true') return;
    knap.setAttribute('data-fn-load', '');
    if (!knap.querySelector('.fn-load__spinner')) {
      var s = document.createElement('span');
      s.className = 'fn-load__spinner';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<span class="fn-load__a"></span><span class="fn-load__b"></span>';
      knap.appendChild(s);
    }
    knap.setAttribute('aria-busy', 'true');
    window.clearTimeout(knap.fnLoadTimer);
    knap.fnLoadTimer = window.setTimeout(function () { loadStop(knap); }, maks || LOAD_MAKS);
  }

  function loadStop(knap) {
    if (!knap) return;
    window.clearTimeout(knap.fnLoadTimer);
    knap.setAttribute('aria-busy', 'false');
  }

  /* Produktsidens egen formular tilfoejer via temaets ajax-kurv og aabner
     kurvskuffen bagefter; <html> faar da js-drawer-open. Det er faerdig-
     signalet. Den sticky bjaelkes knap er en submit med form=, saa den sender
     SAMME formular - derfor spinner den knap der faktisk blev trykket paa
     (event.submitter), ikke bare den foerste paa siden. */
  function opsaetPdpKurv() {
    var forme = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forme.length; i++) {
      var f = forme[i];
      if (f.dataset.fnLoadBundet) continue;
      f.dataset.fnLoadBundet = '1';
      f.addEventListener('submit', function (e) {
        var k = (e && e.submitter) || this.querySelector('.btn--add-to-cart');
        if (!k || k.disabled) return;
        loadStart(k, 6000);
        aktive.push(k);
      });
    }
  }

  var aktive = [];
  function stopAlle() {
    while (aktive.length) loadStop(aktive.pop());
  }

  function opsaetPdpFaerdig() {
    if (document.documentElement.dataset.fnLoadObs) return;
    document.documentElement.dataset.fnLoadObs = '1';
    new MutationObserver(function () {
      if (document.documentElement.classList.contains('js-drawer-open')) stopAlle();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  function opsaetKurv() {
    var knapper = document.querySelectorAll('[data-fn-kurv]');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i];
      if (k.dataset.fnBundet) continue;
      k.dataset.fnBundet = '1';
      k.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var knap = this;
        var tekst = tekstFelt(knap);
        /* Vagt: ligger nummeret allerede i kurven, sker der intet. Knappen er
           slaaet fra i forvejen, men et tastaturtryk eller et dobbeltklik i
           samme oejeblik som svaret lander, ville ellers kunne slippe igennem. */
        if (iKurven(knap.dataset.variant)) { saetKurvKnap(knap); return; }
        knap.disabled = true;
        loadStart(knap);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: parseInt(knap.dataset.variant, 10), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('afvist');
          loadStop(knap);
          /* Tilstanden er nu varig, ikke en kvittering der forsvinder efter
             2,2 sekunder: nummeret ligger i kurven, indtil kunden fjerner det.
             /cart.js bekraefter og udsender fn:kurv, som saetter alle andre
             knapper for samme nummer paa siden. */
          knap.disabled = true;
          saetLaast(knap, true);
          if (window.fnKurv) window.fnKurv.hent();
          /* Arket lukkes FOER kurven aabnes. Ellers ville det staa tilbage
             bag kurvens kort, og de to laase ville overlappe unoedigt. */
          lukKig();
          if (!aabenKurv()) window.location.href = '/cart';
        })['catch'](function () {
          loadStop(knap);
          knap.disabled = false;
          saetTekst(tekst, 'Prøv igen');
        });
      });
    }
  }

  /* ---------- hurtigt kig ---------- */

  var kig = null;

  function byggKig() {
    if (kig) return kig;
    kig = document.createElement('div');
    kig.className = 'fn-kig';
    kig.innerHTML =
      '<div class="fn-kig__kort" role="dialog" aria-modal="true" aria-label="Nummer">' +
      '<span class="fn-kig__greb" aria-hidden="true"></span>' +
      '<button type="button" class="fn-kig__luk" aria-label="Luk">&#10005;</button>' +
      /* Indholdet ruller; bunden klaeber. Uden opdelingen skulle der rulles
         til bunden af kortet for at naa "Læg i kurv", og paa et hoejt kort er
         det netop den knap der skal vaere inden for raekkevidde hele tiden. */
      '<div class="fn-kig__indhold"></div>' +
      '<div class="fn-kig__bund"></div></div>';
    document.body.appendChild(kig);
    kig.addEventListener('click', function (e) {
      if (e.target === kig || e.target.classList.contains('fn-kig__luk')) lukKig();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { lukKig(); lukOenske(); } });
    opsaetKigTraek();
    return kig;
  }

  /* ---------- traek nedad lukker et ark, uanset hvor man tager fat ---------- */

  /* Foer kunne der kun traekkes i grebet. Et ark der glider op nedefra
     forventes at kunne skubbes ned overalt, og et greb paa 40x4 px er et
     lille maal for en tommelfinger.

     Reglen der loeser konflikten med rulningen: et traek bliver foerst til en
     lukning, naar indholdet ligger i TOPPEN og fingeren bevaeger sig nedad.
     Er der rullet ned i listen, ruller den som normalt. Retningen afgoeres
     efter 6 px, saa et almindeligt tryk ikke opfattes som et traek.

     Der lukkes ogsaa paa et hurtigt kast: over 40 px med mere end 0,35 px pr.
     millisekund. Et rigtigt kast med tommelfingeren ligger over 1 px/ms, saa
     graensen rammer ikke et almindeligt, langsomt traek. Uden det skulle man traekke arket halvvejs ned for at lukke,
     hvilket foles tungt. */
  function bindArkTraek(ark, findRulle, luk) {
    if (!ark || ark.dataset.fnArk) return;
    ark.dataset.fnArk = '1';
    var startY = 0, sidsteY = 0, startTid = 0, aktiv = false, laast = false;

    function begynd(e) {
      if (!telefon() || e.touches.length !== 1) return;
      startY = e.touches[0].clientY;
      sidsteY = startY;
      startTid = Date.now();
      aktiv = true;
      laast = false;
    }

    function flyt(e) {
      if (!aktiv) return;
      var y = e.touches[0].clientY;
      var d = y - startY;
      if (!laast) {
        if (Math.abs(d) < 6) return;
        var rulle = findRulle ? findRulle() : null;
        var iTop = !rulle || rulle.scrollTop <= 0;
        if (d > 0 && iTop) {
          laast = true;
          ark.style.transition = 'none';
        } else {
          aktiv = false;          /* opad, eller midt i en rulning: lad den rulle */
          return;
        }
      }
      e.preventDefault();
      sidsteY = y;
      ark.style.transform = 'translateY(' + Math.max(d, 0) + 'px)';
    }

    function slut() {
      if (!aktiv) return;
      aktiv = false;
      if (!laast) return;
      laast = false;
      ark.style.transition = '';
      ark.style.transform = '';
      var d = sidsteY - startY;
      var fart = d / Math.max(Date.now() - startTid, 1);
      if (d > 90 || (d > 40 && fart > 0.35)) luk();
    }

    ark.addEventListener('touchstart', begynd, { passive: true });
    ark.addEventListener('touchmove', flyt, { passive: false });
    ark.addEventListener('touchend', slut, { passive: true });
    ark.addEventListener('touchcancel', slut, { passive: true });
  }

  function opsaetKigTraek() {
    if (!kig) return;
    var kort = kig.querySelector('.fn-kig__kort');
    bindArkTraek(kort, function () { return kig.querySelector('.fn-kig__indhold'); }, lukKig);
  }

  function lukKig() {
    if (!kig || !kig.hasAttribute('data-aaben')) return;
    kig.removeAttribute('data-aaben');
    laasOp();
    /* Soegekortet lytter: naar kig lukkes oven paa det, faar raekken fokus igen. */
    try { window.dispatchEvent(new CustomEvent('fn:kig-lukket')); } catch (e) {}
  }

  /* Beskrivelsen er den samme salgstekst paa alle numre, saa den bruges kun
     som tre korte punkter - ikke i fuld laengde, hvor den ville skubbe
     knapperne under kanten. Punkterne tages fra beskrivelsens egne <li>, og
     falder tilbage paa de foerste linjer, hvis den ikke er en liste. */
  function punkterFra(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var li = d.querySelectorAll('li');
    var ud = [], i;
    for (i = 0; i < li.length && ud.length < 3; i++) {
      var t = (li[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 2) ud.push(t);
    }
    if (!ud.length) {
      var linjer = (d.textContent || '').split(/\n+/);
      for (i = 0; i < linjer.length && ud.length < 3; i++) {
        var l = linjer[i].replace(/\s+/g, ' ').trim();
        if (l.length > 8) ud.push(l);
      }
    }
    return ud;
  }

  /* Moenstertagget er det eneste tag der siger noget om NUMMERET. Resten er
     kollektions- og typetags, som allerede staar andre steder i kortet. */
  function moensterTag(tags) {
    if (!tags) return '';
    var ude = ['alle guldnumre', 'mobil', 'fastnet'];
    for (var i = 0; i < tags.length; i++) {
      if (ude.indexOf(String(tags[i]).toLowerCase()) === -1) return String(tags[i]);
    }
    return '';
  }

  /* Shopifys CDN skalerer selv. Gitterets billede hedder fx `..._370x.png`;
     endelsen fjernes, og der bedes i stedet om den bredde arket bruger.
     Originalen er 1246x640 og er unoedig at hente til et felt paa 350px. */
  function billedUrl(u, bredde) {
    if (!u) return u;
    var ren = u.replace(/_(\d+)x(\d*)(?=\.[a-z]+(\?|$))/i, '');
    return ren + (ren.indexOf('?') === -1 ? '?' : '&') + 'width=' + bredde;
  }

  /* Billedet der ALLEREDE staar i gitteret. Det er hentet og afkodet, saa det
     kan vises i samme oejeblik arket aabner. */
  function kortetsBillede(el) {
    var kort = el && el.closest ? el.closest('[data-product-card]') : null;
    var img = kort ? kort.querySelector('img') : null;
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || '';
  }

  /* "Sidst set" til soegekortet: handles, nyeste foerst, hoejst 8. */
  function noterSet(handle) {
    try {
      var l = JSON.parse(window.localStorage.getItem('fn_sidst_set') || '[]');
      if (!Array.isArray(l)) l = [];
      l = l.filter(function (h) { return h !== handle; });
      l.unshift(handle);
      window.localStorage.setItem('fn_sidst_set', JSON.stringify(l.slice(0, 8)));
    } catch (e) {}
  }

  function aabnKig(handle, forhaandsTitel) {
    noterSet(handle);
    var boks = byggKig();
    var ind = boks.querySelector('.fn-kig__indhold');
    var bund = boks.querySelector('.fn-kig__bund');
    boks.setAttribute('data-fn-handle', handle);
    /* Billedet tegnes FOER opslaget. Maalt: markup'en kom foerst 214 ms efter
       klikket, fordi den ventede paa /products/<handle>.js, og foerst DEREFTER
       begyndte billedet at hente - i fuld stoerrelse. Arket stod altsaa tomt,
       og paa en telefon i meget laengere tid.

       Nu vises gitterets eget billede med det samme (det ligger i cachen), og
       naar opslaget kommer, fyldes kun resten ud. Billedelementet er det
       SAMME hele vejen, saa der hverken hentes forfra eller blinker. */
    ind.innerHTML =
      '<div class="fn-kig__top">' +
      /* Nummerkortet: SVG-skabelonen + titlen, ingen billedforespoergsel.
         Titlen kommer fra gitteret/soegningen med det samme; opslaget
         bekraefter den bagefter. */
      '<span class="fn-nrkort fn-kig__billede" aria-hidden="true"><span class="fn-nrkort__tal">' + esc(forhaandsTitel && forhaandsTitel.indexOf('/') === -1 ? forhaandsTitel.replace(/\s*\(fastnet\)\s*/i, '') : '') + '</span></span>' +
      '</div>' +
      '<div class="fn-kig__resten"><p class="fn-kig__moms">Henter …</p></div>';
    bund.innerHTML = '';
    laasSiden();
    boks.setAttribute('data-aaben', '');
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (boks.getAttribute('data-fn-handle') !== handle) return;
        var v = p.variants && p.variants[0];
        var erFastnet = /\(fastnet\)/i.test(p.title);
        var titel = p.title.replace(/\s*\(fastnet\)\s*/i, '').trim();
        var pris = 'kr. ' + (v ? (v.price / 100) : 0).toLocaleString('da-DK');
        var billede = p.featured_image || (p.images && p.images[0]) || '';
        var url = '/products/' + p.handle;
        var moenster = moensterTag(p.tags);
        var punkter = punkterFra(p.description);

        /* Nummeret staar med store cifre inde i billedet. En overskrift med
           det samme nummer lige under er en gentagelse, der kun tager plads
           fra det, der faktisk skal besluttes: pris, proces og knapper.

           Billedet er allerede tegnet ovenfor. Her opgraderes kun kilden til
           en skarpere variant, og den saettes foerst ind, naar den er faerdig,
           saa arket aldrig staar tomt undervejs. */
        var top = ind.querySelector('.fn-kig__top');
        var tal = top ? top.querySelector('.fn-nrkort__tal') : null;
        if (tal) tal.textContent = titel;
        if (top) {
          top.classList.toggle('fn-is-sold', Boolean(v && !v.available));
          var nummerType = document.createElement('p');
          nummerType.className = 'fn-kig__nummertype';
          nummerType.textContent = erFastnet ? 'Fastnet' : 'Mobil';
          top.appendChild(nummerType);
        }

        /* Hjertet staar UNDER billedet, ikke oven paa det. Oven paa daekkede
           det et hjoerne af selve nummeret. Moensteret staar lige til venstre
           for hjertet i samme hoejde; typen staar yderst til venstre.
           Typepillen ("Mobilnummer"/"Fastnetnummer") er fjernet - den sagde
           det samme som etiketten ved siden af. */
        /* Bogmaerket staar ved siden af "Læg i kurv" i bunden - samme sted som
           paa produktsiden og i den sticky bjaelke. Hvor "Læg i kurv" er, er
           bogmaerket ved siden af. Det baerer de samme data-attributter som
           paa produktkortet, saa opsaetHjerter() kan binde det. */
        var hjerteHtml = '<button type="button" class="fn-kig__hjerte" data-fn-hjerte' +
          ' data-handle="' + esc(p.handle) + '"' +
          ' data-titel="' + esc(titel) + '"' +
          ' data-type="' + (erFastnet ? 'fastnet' : 'mobil') + '"' +
          ' data-pris="' + esc(pris) + '"' +
          ' data-billede="' + esc(billede) + '"' +
          ' data-url="' + esc(url) + '"' +
          ' aria-label="Gem nummeret på ønskelisten" aria-pressed="false">' +
          '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M6 3.8h12a1 1 0 0 1 1 1v15.6l-7-4.3-7 4.3V4.8a1 1 0 0 1 1-1z"/></svg></button>';

        /* Nummertypen staar kun under nummerbilledet. Pris og moms holdes
           samlet i hoejre spalte uden gentagne type- og moenstermaerker. */
        var html = '<div class="fn-kig__prislinje">' +
          '<p class="fn-kig__pris">' + esc(pris) + '</p>' +
          '</div>' +
          '<p class="fn-kig__moms">ekskl. moms</p>';

        /* Flere oplysninger paa desktop (7. september 2026): et lille
           faktagitter og Trustpilot-linjen fra den skjulte skabelon i
           layout/theme.liquid (#FnTpSkabelon), som Liquid har renderet. */
        var tpSkab = document.getElementById('FnTpSkabelon');
        html += '<dl class="fn-kig__fakta">' +
          '<div><dt>Levering</dt><dd>På mail samme dag</dd></div>' +
          '<div><dt>Binding</dt><dd>Ingen - du vælger selv teleselskab</dd></div>' +
          '<div><dt>Bytteservice</dt><dd>100 dage</dd></div>' +
          '<div><dt>Prisgaranti</dt><dd>14 dage efter køb</dd></div>' +
          '</dl>';

        /* Processen i én raekke. Teksten er butikkens egen: et mobilnummer
           overdrages med SIM-kortnummeret (ICC), et fastnetnummer med
           kundenummeret hos det nuvaerende selskab - se /pages/overdragelse
           og `snippets/nummeroverdragelse.liquid`. Skriv ikke "SIM-kort" paa
           et fastnetnummer; de har ingen. */
        html += '<ol class="fn-kig__proces">' +
          '<li><span class="fn-kig__trin">1</span>' +
          '<span class="fn-kig__trin-tekst">Vi sender dig ' +
          (erFastnet ? 'kundenummeret' : 'sim-kort nummeret') + '</span></li>' +
          '<li><span class="fn-kig__trin">2</span>' +
          '<span class="fn-kig__trin-tekst">Oplys det til dit foretrukne teleselskab</span></li>' +
          '<li><span class="fn-kig__trin">3</span>' +
          '<span class="fn-kig__trin-tekst">Dit teleselskab klarer resten. Flytningen tager kun <b>1-3 dage</b></span></li>' +
          '</ol>';

        /* Stor "Laeg i kurv" lige under de tre trin (Richard 07.09.2026): koebet ligger der,
           hvor man netop har laest, hvordan det foregaar. Samme handler som knappen i bunden. */
        if (v && v.available) {
          /* Kun "Læg i kurv" i knappen. Prisen og "ekskl. moms" staar i
             forvejen i .fn-kig__prislinje lige ovenover, og gentagelsen tog
             plads fra selve handlingen (Richard 08.09.2026). */
          html += '<button type="button" class="fn-kig__knap fn-kig__knap--kurv fn-kig__knap--stor" data-fn-kurv data-variant="' + v.id + '"><span>Læg i kurv</span></button>';
        }

        html += tpSkab ? '<div class="fn-kig__tp">' + tpSkab.innerHTML + '</div>' : '';

        if (punkter.length) {
          var punkterHtml = '<ul class="fn-kig__punkter">';
          for (var i = 0; i < punkter.length; i++) punkterHtml += '<li>' + esc(punkter[i]) + '</li>';
          punkterHtml += '</ul>';
          if (top && window.matchMedia('(min-width: 769px)').matches) {
            top.insertAdjacentHTML('beforeend', punkterHtml);
          } else {
            html += punkterHtml;
          }
        }

        /* Paa desktop er bunden en bred bjaelke: nummer og pris til venstre,
           knapperne til hoejre. Teksten skjules i CSS paa telefon, hvor
           nummeret staar i billedet lige ovenfor. */
        var bundTekst = '<div class="fn-kig__bundtekst"><span class="fn-kig__bundnr">' + esc(titel) + '</span>' +
          '<span class="fn-kig__bundpris">' + esc(pris) + ' ekskl. moms</span></div>';
        var bundHtml;
        if (v && v.available) {
          bundHtml = bundTekst + '<div class="fn-kig__knapper">' +
            '<div class="fn-kig__koebraekke">' +
            '<button type="button" class="fn-kig__knap fn-kig__knap--kurv" data-fn-kurv data-variant="' + v.id + '"><span>Læg i kurv</span></button>' +
            hjerteHtml + '</div>' +
            '<a class="fn-kig__knap fn-kig__knap--side" href="' + esc(url) + '">Se mere</a></div>';
        } else {
          html += '<p class="fn-kig__udsolgt">Dette nummer er solgt.</p>';
          bundHtml = bundTekst + '<div class="fn-kig__knapper">' +
            '<a class="fn-kig__knap fn-kig__knap--side" href="/collections/alle-guldnumre">Se ledige guldnumre</a></div>';
        }
        var resten = ind.querySelector('.fn-kig__resten');
        if (resten) resten.innerHTML = html; else ind.innerHTML = html;
        bund.innerHTML = bundHtml;
        opsaetKurv();
        opsaetHjerter();
      })
      ['catch'](function () {
        if (boks.getAttribute('data-fn-handle') !== handle) return;
        var r = ind.querySelector('.fn-kig__resten') || ind;
        r.innerHTML = '<p class="fn-kig__moms">Nummeret kunne ikke hentes. <a href="/products/' + esc(handle) + '">Åbn siden</a>.</p>';
      });
  }

  function opsaetKig() {
    var knapper = document.querySelectorAll('[data-fn-kig]');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i];
      if (k.dataset.fnBundet) continue;
      k.dataset.fnBundet = '1';
      k.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        aabnKig(this.dataset.handle, kortetsBillede(this));
      });
    }
  }

  /* Et klik paa nummeret i gitteret aabner arket i stedet for at gaa til
     produktsiden. Linket bliver staaende i markup'en, og `href` roeres ikke:
     soegemaskiner og skaermlaesere foelger det som foer, og "Se mere" inde i
     arket gaar samme sted hen. Kun det almindelige venstreklik opfanges -
     Cmd-, Ctrl-, Shift- og midterklik faar lov, saa numre stadig kan aabnes
     i en ny fane. */
  function handleFra(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  /* Titlen fra kortet: nummerkortets tekst, ellers den skjulte titel. */
  function kortetsTitel(a) {
    var kort = a.closest ? a.closest('[data-product-card]') : null;
    var t = kort ? (kort.querySelector('.fn-nrkort__tal') || kort.querySelector('.grid-product__title')) : null;
    return t ? t.textContent.trim() : '';
  }
  /* Forhaandsvisningen ved klik paa et nummer er slaaet fra igen (Richard,
     11. september 2026). Linkets EGEN href goer nu arbejdet: et klik gaar
     direkte til produktsiden, som det gjorde foer arket blev bygget.
     Funktionen er kun taget ud af drift, ikke slettet - giv den sin gamle
     krop tilbage for at slaa arket til igen. Selve arket (aabnKig,
     byggKig m.fl.) er urort og bruges stadig af soegekortet, se
     firmanumre-soeg.js. */
  function opsaetKortKlik() {}

  /* ---------- oenskelistesiden ---------- */

  function tegnOenskeliste() {
    var net = document.querySelector('[data-fn-oenske-net]');
    if (!net) return;
    var tom = document.querySelector('[data-fn-oenske-tom]');
    var liste = laes();
    if (!liste.length) {
      net.innerHTML = '';
      if (tom) tom.hidden = false;
      return;
    }
    if (tom) tom.hidden = true;
    net.innerHTML = liste.map(function (x) {
      /* Kun billede, pris og bogmaerket (fyldt, i cirkel), som fjerner
         nummeret. Ingen titel - nummeret staar i kortet. */
      return '<article class="fn-oenske__kort" data-fn-oenske-handle="' + esc(x.handle) + '">' +
        '<a class="fn-oenske__link" href="' + x.url + '" aria-label="' + x.titel + '"><span class="fn-nrkort" aria-hidden="true"><span class="fn-nrkort__tal">' + x.titel + '</span></span></a>' +
        '<button type="button" class="fn-gem fn-oenske__gem" data-fjern="' + x.handle + '" aria-pressed="true" aria-label="Fjern ' + x.titel + ' fra ønskelisten">' +
        '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3.8h12a1 1 0 0 1 1 1v15.6l-7-4.3-7 4.3V4.8a1 1 0 0 1 1-1z"/></svg></button>' +
        '<p class="fn-oenske__pris">' + (x.pris || '') + '<small>ekskl. moms</small></p>' +
        '</article>';
    }).join('');
    var kort = net.querySelectorAll('[data-fn-oenske-handle]');
    Array.prototype.forEach.call(kort, function (kortEl) {
      var handle = kortEl.getAttribute('data-fn-oenske-handle');
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product unavailable'); return r.json(); })
        .then(function (p) {
          if (!kortEl.isConnected || typeof p.available !== 'boolean') return;
          kortEl.classList.toggle('fn-is-sold', !p.available);
          if (!p.available) {
            var label = document.createElement('span');
            label.className = 'fn-sold-ribbon'; label.textContent = 'Solgt';
            kortEl.querySelector('.fn-oenske__link').appendChild(label);
          }
        })['catch'](function () {});
    });
    var f = net.querySelectorAll('[data-fjern]');
    for (var i = 0; i < f.length; i++) {
      f[i].addEventListener('click', function () {
        skriv(laes().filter(function (x) { return x.handle !== this.dataset.fjern; }.bind(this)));
        tegnOenskeliste();
      });
    }
  }

  /* ---------- oenskelisten som kort ---------- */

  function aabnOenske(e) {
    var boks = document.getElementById('OenskeDrawer');
    if (!boks) return;                    /* uden skuffen foelges linket */
    if (e) e.preventDefault();
    tegnOenskeliste();
    boks.hidden = false;
    /* Et billede skal males, foer overgangen kan ses. */
    laasSiden();
    window.requestAnimationFrame(function () { boks.setAttribute('data-aaben', ''); });
  }

  function lukOenske() {
    var boks = document.getElementById('OenskeDrawer');
    if (!boks) return;
    boks.removeAttribute('data-aaben');
    laasOp();
    window.setTimeout(function () { boks.hidden = true; }, 340);
  }

  function opsaetOenskeKort() {
    var aabnere = document.querySelectorAll('[data-fn-oenske-aaben]');
    for (var i = 0; i < aabnere.length; i++) {
      if (aabnere[i].dataset.fnBundet) continue;
      aabnere[i].dataset.fnBundet = '1';
      aabnere[i].addEventListener('click', aabnOenske);
    }
    var lukkere = document.querySelectorAll('[data-fn-oenske-luk]');
    for (var j = 0; j < lukkere.length; j++) {
      if (lukkere[j].dataset.fnBundet) continue;
      lukkere[j].dataset.fnBundet = '1';
      lukkere[j].addEventListener('click', lukOenske);
    }
  }

  function opsaetOenskeTraek() {
    var ark = document.querySelector('.fn-oenske-kort__ark');
    bindArkTraek(ark, function () { return ark.querySelector('.fn-oenske-kort__krop') || ark; }, lukOenske);
  }

  /* ---------- start ---------- */

  function bind() {
    opsaetHjerter();
    opsaetKurv();
    opsaetKig();
    opsaetKortKlik();
    opsaetOenskeKort();
    opsaetOenskeTraek();
    opsaetPdpKurv();
    opsaetPdpFaerdig();
    opdaterKurvKnapper();
    opdaterTal();
  }

  function start() {
    bind();
    tegnOenskeliste();
    window.addEventListener('fn:oenskeliste', tegnOenskeliste);
    window.addEventListener('fn:kurv', opdaterKurvKnapper);
    /* Produktgitre tegnes om af Slick og af temaets filtre, saa knapperne
       bindes igen, naar der kommer nye kort.

       Malt paa forsiden 11. september 2026 (instrumenteret i Patchright: talt
       antal kald til `document.querySelectorAll('[data-fn-oenske-tal]')`,
       som sker praecis én gang pr. bind()): UDEN debounce kaldte denne
       observer bind() 15 gange i de foerste fem sekunder, hver med flere
       `querySelectorAll` over HELE siden - samme fejl som firmanumre-kurv.js
       allerede har rettet paa #CartContainer, bare uden en debounce og uden
       at vaere scopet til ét element. MED debouncen herunder: 3 gange paa
       samme fem sekunder. Mutationerne samles nu i ét bind() pr. byge,
       ligesom kurvens. */
    var kortBindVenter = null;
    var obs = new MutationObserver(function () {
      if (kortBindVenter) window.clearTimeout(kortBindVenter);
      kortBindVenter = window.setTimeout(function () { kortBindVenter = null; bind(); }, 30);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Soegekortet (firmanumre-soeg.js) genbruger arkets hjaelpere, saa der
     ikke findes to sidelaase, to traek-lukkere og to bogmaerkebindinger. */
  window.fnKort = { aabnKig: aabnKig, lukKig: lukKig, laasSiden: laasSiden, laasOp: laasOp,
                    bindArkTraek: bindArkTraek, opsaetHjerter: opsaetHjerter, esc: esc, telefon: telefon };
  /* Telenor-spinneren, saa andre moduler kan vise samme tilstand. */
  window.fnLoad = { start: loadStart, stop: loadStop };
})();
